export default "__VITE_PUBLIC_ASSET__c89f9e2f__"